import { Types } from './types'

const initialState = {
    dataCompany: {
        filter: {},
        rows: []
    },
    currentRecord: null
}
const companyReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_COMPANY:
            return {
                ...newState,
                dataCompany: action.payload
            }
        case Types.SET_RECORD:
            return {
                ...newState,
                currentRecord: action.payload
            }
        default:
            return {...newState }
    }
}
export default companyReducer